import '../index.scss';
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { translate } from '@utils';
import { MgState, TranslationKey } from '@types';

interface Props {
  contentName: TranslationKey;
  handleCancel: () => void;
  handleConfirmation: () => void;
}

export const MarkAsSentModal = ({ contentName, handleCancel, handleConfirmation }: Props) => {
  const checkedAnswersIds = useSelector<MgState, string[]>(
    ({ answer }) => answer.checkedAnswersIds
  );

  const isOpenMarkAsSentModal = useSelector<MgState, boolean>(
    ({ answersPage }) => answersPage.isOpenMarkAsSentModal
  );

  const isMarkingAsSentLoading = useSelector<MgState, boolean>(
    ({ answer }) => answer.isMarkingAsSentLoading
  );

  const title =
    checkedAnswersIds.length > 1
      ? translate('mark_as_sent_answers')
      : translate('mark_as_sent_answer');

  return (
    <Dialog
      className="reassign-modal"
      keepMounted
      open={isOpenMarkAsSentModal}
      onClose={handleCancel}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText className="reassign-modal__content-text">
          {translate(contentName)}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button
          className="actions-button save"
          data-testid="apply"
          onClick={handleConfirmation}
          disabled={isMarkingAsSentLoading}
          disableRipple
        >
          {translate('apply')}
        </Button>
        <Button className="actions-button cancel" onClick={handleCancel} disableRipple>
          {translate('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
